<template>
  <span class="w-auto pointer position-relative" @click="showDish()">
    <SectionImageComponent :image="$responsive(dish.pictures)" />
    <LikeComponent v-if="dish.likes" :likes="dish.likes" position="top-right" @click.stop="false" />
    <RatingComponent v-if="dish.rating" :rating="dish.rating" class="position-absolute" style="top: 15px; left: 20px; background-color:rgba(255,255,255,0.7); border-radius: 10px; padding-left:5px; padding-right:5px;" />
    <CookHeadComponent v-if="dish.cook_cartoon_picture" :image="$responsive(dish.cook_cartoon_picture)" />

    <BadgeComponent :badgeImage="$responsive(dish.pictures.badge)" v-if="dish.pictures.badge" />
  </span>

  <div class="margin-tlr-20 d-flex flex-column desktop-only" v-if="dish.sections.cook_info">
    <!-- <span class="w-auto pointer position-relative" @click="showCook()"> -->
    <a :href="dish.sections.cook_info.title.href" class="w-auto black-link pointer position-relative">
      <div class="f17-l19-m flex-grow-1 text-truncate-on-carousel" v-html="dish.sections.cook_info.title.text_html"></div>
    <!-- </span> -->
    </a>
    <div class="f14-l18 bold red two-lines-on-carousel two-lines-on-search text-truncate-on-carousel">{{dish.sections.cook_info.subtitle.text}}</div>
  </div>

</template>
<script>
  import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
  import RatingComponent from "@/components/generic/RatingComponent.vue";
  import LikeComponent from "@/components/generic/LikeComponent.vue";
  import CookHeadComponent from "@/components/CookHeadComponent.vue";
  import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
  import BadgeComponent from "@/components/BadgeComponent.vue";
  export default {
    components: {
      RatingComponent,
      SectionImageComponent,
      // DishPreferenceComponent,
      LikeComponent,
      CookHeadComponent,
      BadgeComponent
    },
    props: {
      dish: Object
    },
    methods: {
      showDish() {
        this.$router.push(this.dish.url);
        this.trackClick();
        // this.$store.dispatch('fetchDish', this.dish.url);
        // let offcanvas = document.getElementById("offcanvasExample");
        // var bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
        // bsOffcanvas.show();
      },
      showCook() {
        this.$router.push(this.dish.sections.cook_info.title.href);
        this.trackClick();
      },
      trackClick() {
      // Trigger Google Tag Manager event
      if (this.dish.data_layer) {
          // console.log("tracking data layer: ", this.dish.data_layer)
          addGoogleAnalyticsDataLayer(this.dish.data_layer);
        }
      },
    }

  }
</script>